import {query} from "../utils/api";

const GET_GROWOP_LIST_URL = `${process.env.PUBLIC_URL}/api/v1/r/growOpList`;
export const GET_GROWOP_LIST = "GET_GROWOP_LIST";
export const GET_GROWOP_LIST_COMPLETED = "GET_GROWOP_LIST_COMPLETED";
export const GET_GROWOP_LIST_FAILED = "GET_GROWOP_LIST_FAILED";
export function getGrowOpList() {
  const filter = {
    order: "name ASC"
  };
  return query(GET_GROWOP_LIST_URL, filter, GET_GROWOP_LIST, GET_GROWOP_LIST_COMPLETED, GET_GROWOP_LIST_FAILED);
}

export const SELECT_GROWOP = "SELECT_GROWOP";
export function selectGrowOp(growOpId) {
  return {type: SELECT_GROWOP, payload: {growOpId}};
}



// WEBPACK FOOTER //
// ./src/GrowOp/actions.js